import React from "react";
import PropTypes from "prop-types";
import { Table, Divider, Input, Button, Tooltip } from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditOutlined,
  FileTextOutlined,
  ApartmentOutlined,
  BlockOutlined,
} from "@ant-design/icons";
import {
  ServiceActions,
  ServiceDeploymentEnum,
  ServiceTypes,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../Constants/Constants";
import { StatusSwitch } from "../Common/StatusSwitch";
import {
  createFilter,
  defaultSort,
  getTablePagesize,
  setTablePageSize,
} from "../../Constants/Utilities";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ListService extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListService props", props);
    this.state = {
      serviceData: props.serviceData,
    };
  }

  getColumns = () => [
    {
      title: "Service Name",
      dataIndex: "name",
      sorter: (a, b) => defaultSort(a.name, b.name),
      defaultSortOrder: "ascend",
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(ServiceActions.view, record)}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      filters: createFilter(ServiceTypes),
      onFilter: (value, record) => record.type === value,
      sorter: (a, b) => defaultSort(a.type, b.type),
    },
    {
      title: "Deployment",
      dataIndex: "deployment",
      filters: createFilter(ServiceDeploymentEnum),
      onFilter: (value, record) => record.deployment === value,
      sorter: (a, b) => defaultSort(a.deployment, b.deployment),
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Service">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(ServiceActions.view, record)}
            />
          </Tooltip>
          <Tooltip title="Edit Service">
            <EditOutlined
              className="entity-action"
              onClick={this.props.onActionClick(ServiceActions.edit, record)}
            />
          </Tooltip>
          <Tooltip title="Service Dependencies">
            <ApartmentOutlined
              className="entity-action"
              onClick={this.props.onActionClick(
                ServiceActions.dependency,
                record
              )}
            />
          </Tooltip>
          <Tooltip title="Service Instances">
            <BlockOutlined
              onClick={this.props.onActionClick(
                ServiceActions.instance,
                record
              )}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  componentDidUpdate(prevProps) {
    if (prevProps.serviceData !== this.props.serviceData) {
      this.setState({ serviceData: this.props.serviceData });
    }
  }

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { serviceData } = this.props;
    if (!!text) {
      const filteredData = serviceData.filter((item) =>
        item.name.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ serviceData: filteredData });
      return;
    }
    this.setState({ serviceData });
  };

  render() {
    const { serviceData } = this.state;
    const { serviceDataLoading, onActionClick } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={this.props.parentBread} />
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Service Name"
              onChange={this.onSerchTextChange}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ServiceActions.add, null)}
            >
              Add Service
            </Button>
          </div>
        </div>
        <Table
          bordered
          size="small"
          columns={this.getColumns()}
          className="entity-table"
          loading={serviceDataLoading && { tip: "Fetching Service list..." }}
          dataSource={serviceData}
          pagination={{
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            defaultPageSize: getTablePagesize(TablePages.listService),
            pageSizeOptions: TablePageSizes,
            onChange: (_, pageSize) =>
              setTablePageSize(TablePages.listService, pageSize),
          }}
        />
      </div>
    );
  }
}

ListService.propTypes = {
  serviceData: PropTypes.array,
  serviceDataLoading: PropTypes.bool,
  onActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
};

export default ListService;
